import print from "./js/init";
import "./sass/index.scss";

const printJS = print.init;

if (typeof window !== "undefined") {
  window.printJS = printJS;
}

export default printJS;
